<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Ajout d'un groupe</h1>
                <div class="pageOptions">
                    <btn text="Enregistrer" ico="valide" @click="save"
                         v-if="$store.getters.hasPerm('group:add/edit')"></btn>
                    <btn ico="times" color="red" @click="cancel" v-if="$store.getters.hasPerm('group:add/edit')"></btn>
                </div>
            </div>
        </div>
        <form>
            <div class="large mb">
                <label for="label">Libelle du groupe</label>
                <input type="text" v-model="group.label" id="label">
            </div>
        </form>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import Loader from "@/components/Loader";
    import axios from 'axios';
    import tools from '../config.ts';

    export default {
        name: "Group",
        components: {Btn, Loader},
        data() {
            return {
                group: {},
                groupId: {},

                btnAjoute: "Ajoute",
            }
        },
        methods: {

            load() {

                if (!this.groupId) {
                    tools.loader(false);
                    return;
                }

                axios.get(tools.api("group/" + this.groupId), tools.headerGET())
                    .then((response) => {
                        this.group = response.data;
                        tools.loader(false);
                    })
            },
            save() {
                let url = "group";

                if (this.groupId) {
                    url += "/" + this.groupId;
                }

                tools.loader(true);

                axios.post(tools.api(url), tools.toPOST({
                    id: this.groupId,
                    label: this.group.label,
                }), tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'enregistrement du groupe",
                            });
                        }
                        this.$router.push("/groups")
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement du groupe. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            cancel(){
                tools.popup("confirm",{
                    title:"Confirmation",
                    message :"Voulez-vous vraiment annuler les modifications ?",
                    success : () => {
                        this.$router.push("/groups");
                    }
                })
            }
        },
        mounted(){

            if(!this.$store.getters.hasPerm('group:add/edit')){
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode",true);

            this.groupId = this.$route.params.id;

            this.load();
        }
    }
</script>